import React from "react";

import { Card, Grid, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const VARIANT_BGS = {
  dark: "rgba(0, 0, 0, 0.20)",
  medium: "rgba(0, 0, 0, 0.05);",
  light: "rgba(255, 255, 255, 0.20)",
  outline: "",
};

const useStyles = makeStyles()((theme) => ({
  outer: {
    display: "flex",
    borderRadius: "18px",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2),

    // horizontal
    "@media (orientation: landscape)": {
      flexDirection: "column",
    },
  },
  children: {
    // vertical
    flex: 1,
    height: "100%",
    width: "100%",

    // horizontal
    "@media (orientation: landscape)": {
      flex: 2,
    },
  },
  textWrapper: {
    flexDirection: "column",

    // vertical
    flex: 3,

    // horizontal
    "@media (orientation: landscape)": {
      flex: 1,
      textAlign: "center",
      justifyContent: "center",
    },
  },
}));

export const RetroCard = ({
  children,
  variant,
  mainInfo,
  caption,
  mainSuffix = "",
  gridColumnVertical,
  gridColumnHorizontal,
  gridRowVertical,
  gridRowHorizontal,
}: RetroCardProps) => {
  const { classes } = useStyles();
  return (
    <Card
      className={classes.outer}
      sx={{
        background: VARIANT_BGS[variant],
        "@media (orientation: landscape)": {
          gridColumn: gridColumnHorizontal,
          gridRow: gridRowHorizontal,
        },
        "@media (orientation: portrait)": {
          gridColumn: gridColumnVertical,
          gridRow: gridRowVertical,
        },
      }}
    >
      {children && (
        <Grid item container className={classes.children}>
          {children}
        </Grid>
      )}
      {mainInfo && (
        <Grid
          item
          container
          className={classes.textWrapper}
          sx={{
            "@media (orientation: landscape)": {
              textAlign: "center",
            },
            "@media (orientation: portrait)": {
              textAlign: children ? "left" : "center",
            },
          }}
        >
          <Typography
            color="common.white"
            variant="h1"
            component="span"
            sx={{ m: 0 }}
          >
            {mainInfo}
            {mainSuffix ? ` ${mainSuffix}` : ""}
          </Typography>
          <Typography variant="body2" color="common.white">
            {caption}
          </Typography>
        </Grid>
      )}
    </Card>
  );
};

export type RetroCardProps = React.PropsWithChildren<{
  variant: "dark" | "medium" | "light" | "outline";
  gridColumnVertical: string;
  gridColumnHorizontal: string;
  gridRowVertical: string;
  gridRowHorizontal: string;
  mainInfo?: string;
  caption?: string;
  mainSuffix?: string;
}>;
